/* eslint-disable @typescript-eslint/camelcase */
import Apis from 'apis';
import { objToQueryString } from 'utils/helpers';

export const api = Apis({});

interface QueryProps {
  limit?: number | string;
  offset?: number | string;
  search?: string;
  status?: string;
  period?: string;
}

export default {
  getBlockedEnvironmentsData: (query: QueryProps) =>
    `/monitor/blocked-environment/?${objToQueryString(query)}`,
  getEnvironmentHealthData: (query: QueryProps) =>
    `/monitor/environment-health/?${objToQueryString(query)}&status=analyze`,
  getInstanceStatusData: (query: QueryProps) =>
    `/monitor/scale-instance-status/?${objToQueryString(query)}&status=failed`,
  getInstancesWithSessionTimeout: (query: QueryProps) =>
    `/monitor/scale-instance-status/sessions-timeout/?${objToQueryString(
      query
    )}`,
  getEnvironmentAndCeleryQueueStatus: () =>
    `/monitor/environment-health-summary/`,
  getSessionsHistoryMonitorGraph: (
    intervalTime: string,
    start_date?: string,
    end_date?: string
  ) =>
    `/monitor/graphs/environments/?end-date=${end_date}&period=${intervalTime}&start-date=${start_date}`,
  getClientsHistoryMonitorGraph: (intervalTime: string) =>
    `/monitor/client/created-clients/?period=${intervalTime}`,
  getUsersHistoryMonitorGraph: (intervalTime: string) =>
    `/monitor/user/created-users/?period=${intervalTime}`,
  getEnvironmentsCostMonitorGraph: (intervalTime: string) =>
    `/monitor/graphs/environments-cost/?period=${intervalTime}`,

  getMonthlyEnvironmentsCostMonitorGraph: () =>
    '/monitor/graphs/monthly-environments-cost/',
  getFlavorsCost: (query: QueryProps) =>
    `/monitor/costs/flavors/?${objToQueryString(query)}`,
  getFlavorEnvironments: (query: QueryProps) =>
    `/monitor/costs/flavors/environments/?${objToQueryString(query)}`,
  getEnvironmentsWithFailedZeroTrust: (query?: QueryProps) =>
    `/monitor/environment/failed-zero-trust/?${objToQueryString(query)}`,
};
